import React from "react";
import Header from "./Header";
import google_pay_icon from "../assets/images/svg/google_pay_icon.svg";
import user_icon from "../assets/images/svg/users_icon.svg";
import app_stor_icon from "../assets/images/svg/app_staor_icon.svg";
import mobile_img from "../assets/images/png/mobile_image.png";

const Hero = () => {
  return (
    <div className="bg-[linear-gradient(0deg,_#060103_0%,_#870022_100%)]  sm:min-h-full sm:pb-10 lg:pb-10 md:pb-10  xl:pb-10 xs:pt-4 sm:pt-4 xs:pb-10 xs:min-h-full  min-h-screen flex flex-col">
  

      <div>
        <Header />
      </div>
      <div className="xl:px-[10%] lg:px-[8%] xs:px-[5%] md:px-[6%] sm:px-[5%]   py-4 flex flex-col justify-center   sm:flex-grow-0 xs:flex-grow-0 flex-grow">

      <div className="flex xs:flex-col  items-center justify-between">

      <div className="xs:w-full  w-1/2">
      <h1 className="mb-0  xs:text-center xs:text-[34px] sm:text-[45px]  text-start md:text-left font-bold lg:text-[65px] md:text-7xl text-white">
  Friends don’t <br /> let text friends late
</h1>

<p className="text-white xs:text-center text-start md:text-left xs:text-[17px] text-[20px] font-semibold">
  Let’s install Drunkmates
</p>

<div className="flex xs:flex-row flex-row xs:justify-center justify-start gap-2 sm:gap-4 mt-3 sm:mt-0">
  <a href="https://play.google.com/store/apps/details?id=com.drunkmatesblocker.app">
    <img className="mt-3 sm:mt-0 custom_width" src={google_pay_icon} alt="google_pay_icon" />
  </a>
  <a href="https://apps.apple.com/us/app/drunkmates-application/id6538718402">
    <img className="mt-3 sm:mt-0 custom_width" src={app_stor_icon} alt="app_stor_icon" />
  </a>
</div>

          </div>
          <div className="xs:w-full  w-1/2 mt-5 md:mt-0">
  <img className="w-full " src={mobile_img} alt="mobile_img" />
</div>

        </div>
      </div>
    </div>
  );
};

export default Hero;
